import { useEffect, useRef, useState } from "react";
import { get, patchRequest } from "../../../http/api";
import noImgProfile from '../../../no-image-icon-23479.png'
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../config";
import { getMediaUrl } from "../../../http/media";


export default function MediaSection() {
  const fileInputRef = useRef(null);
  const [photo, setPhoto] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [photoLoading, setPhotoLoading] = useState(true);

  const { t } = useTranslation();




  const fetchPhoto = async () => {
    setPhotoLoading(true);
    try {
      const res = await get("profile/photo");

      if (res.data?.photo_url) {
        setPreview(
          `${getMediaUrl(res.data.photo_url)}?t=${Date.now()}`
        );
      } else {
        setPreview(null);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setPhotoLoading(false);
    }
  };

  /* FETCH CURRENT PHOTO */
  useEffect(() => {
    fetchPhoto();
  }, []);

  /* OPEN FILE PICKER */
  const openPicker = () => {
    fileInputRef.current.click();
  };

  /* HANDLE FILE */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPhoto(file);
    setPreview(URL.createObjectURL(file));
  };

  /* UPLOAD */
  const handleUpload = async () => {
    if (!photo) return;

    const formData = new FormData();
    formData.append("photo", photo);

    setLoading(true);
    try {
      await patchRequest("profile/photo", formData, true);
      setPhoto(null);
      fetchPhoto();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="settings-card">
      <h3>
        {t("mediaSection.title")}
      </h3>

      <div className="photo-wow-wrapper">
        <div className="photo-wow" onClick={openPicker}>

          {photoLoading && (
            <div className="photo-skeleton" />
          )}

          {preview && (
            <img
              src={preview}
              onLoad={() => setPhotoLoading(false)}
              onError={() => setPhotoLoading(false)}
              className={photoLoading ? "hidden" : ""}
            />
          )}

          {!preview && !photoLoading && (
            <img
              src={noImgProfile}
              alt={t("mediaSection.photo.fallbackAlt")}
            />
          )}

          <div className="photo-wow-overlay">
            {loading
              ? t("mediaSection.photo.loading")
              : t("mediaSection.photo.edit")}
          </div>
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          hidden
          onChange={handleFileChange}
        />
      </div>

      <small>
        {t("mediaSection.help.recommended")}
      </small>

      <div className="settings-actions">
        <button
          className="btn primary"
          onClick={handleUpload}
          disabled={loading || !photo}
        >
          {loading
            ? t("mediaSection.buttons.uploading")
            : t("mediaSection.buttons.updatePhoto")}
        </button>
      </div>
    </section>
  );
}